import Slider from '@mui/material/Slider';
import { styled } from "@mui/material/styles";
import { SyntheticEvent, useState } from 'react';

const CustomSlider = styled(Slider)({
  height: 12,
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 60,
    width: 60,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginLeft: -14,
  },
  "& .MuiSlider-track": {
    height: 15,
    borderRadius: 6,
  },
  "& .MuiSlider-rail": {
    height: 15,
    borderRadius: 6,
  },
});

interface SpinSliderProps {
  onSpin: (direction: 'clockwise' | 'counterclockwise', spinSpeed: number) => void;
}

const SpinSlider: React.FC<SpinSliderProps> = ({
  onSpin,
}) => {
  const [sliderValue, setSliderValue] = useState(50);
  const [rotationDegrees, setRotationDegrees] = useState(0);

  const handleChange = (_event: Event | SyntheticEvent, value: number | number[]) => {
    const newValue = value as number;
    const direction = newValue < sliderValue ? 'counterclockwise' : 'clockwise';
    const rotationDegrees = Math.abs(newValue - sliderValue) * 3.6; // 0-100 slider to degrees
    setSliderValue(newValue);
    setRotationDegrees(prev => direction === 'clockwise' 
      ? prev + rotationDegrees 
      : prev - rotationDegrees);
  };

  const handleCommit = (_event: Event | SyntheticEvent, value: number | number[]) => {
    const finalValue = value as number;
    const direction = finalValue < 50 ? 'counterclockwise' : 'clockwise';
    const spinSpeed = Math.abs(finalValue - 50) > 25 ? 1 : 2; // Faster if far from center
    onSpin(direction, spinSpeed);
    setSliderValue(50); // Reset slider to center
  };

  return (
    <>
      <style>
        {`
          .wheel-container > div > div {
            transform: rotate(${-73 + rotationDegrees}deg);
            transition: transform 0.1s ease-out;
          }
        `}
      </style>
      <div className="spin-slider">
        <CustomSlider
          color="error"
          min={0}
          max={100}
          value={sliderValue}
          onChange={handleChange}
          onChangeCommitted={handleCommit}
        />
      </div>
    </>
  );
};

export default SpinSlider;